/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/_asciiToArray.js
// module id = ./node_modules/recharts/node_modules/lodash/_asciiToArray.js
// module chunks = 1